import { render } from "./MobileNotes.vue?vue&type=template&id=a7d9eb40&scoped=true"
import script from "./MobileNotes.vue?vue&type=script&lang=js"
export * from "./MobileNotes.vue?vue&type=script&lang=js"

import "./MobileNotes.vue?vue&type=style&index=0&id=a7d9eb40&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7d9eb40"]])

export default __exports__